// A won revenue deal is placement evidence only with a linked candidate and a
// vacancy or an explicit candidate start date. A generic won BD deal is not.
export const legacyPlacementDealSql = (a) => `(${a}.deal_stage_label = 'Won'
  AND NULLIF(${a}.candidate_slug, '') IS NOT NULL
  AND (NULLIF(${a}.job_slug, '') IS NOT NULL OR EXISTS (
    SELECT 1 FROM jsonb_array_elements(CASE WHEN jsonb_typeof(${a}.data->'custom_fields') = 'array'
      THEN ${a}.data->'custom_fields' ELSE '[]'::jsonb END) lpf
    WHERE lpf->>'field_name' = 'Startdatum kandidaat' AND lpf->>'value' ~ '^[0-9]{4}-[0-9]{2}-[0-9]{2}')))`;
export const legacyDealPlacementEver = (s) => `EXISTS (SELECT 1 FROM rcrm_deals lpd WHERE lpd.candidate_slug = ${s} AND ${legacyPlacementDealSql('lpd')})`;
